import uniqueId from 'lodash/uniqueId';
import Col from '~/grid/Col';
import { ContainerLargeType } from '../ContainerLarge.helpers';

/**
 * @param {Array<ColDefinition>} cols
 * @param {Array<React.ReactNode>} elements
 * @param {number | undefined} [customGutter]
 * @param {boolean | undefined} [enlargeBottom]
 * @returns {React.ReactElement}
 */
const createCols = (cols, elements, customGutter, enlargeBottom) => (
  <>
    {cols.map((col, index) => (
      <Col
        key={uniqueId('col_')}
        gutter={customGutter}
        colAmount={col.colAmount}
        enlargeBottom={enlargeBottom}
      >
        {elements[index]}
      </Col>
    ))}
  </>
);

/**
 * @param {ContainerLargeType} type
 * @param {Array<React.ReactNode>} elements
 * @param {number | undefined} [customGutter]
 * @returns {React.ReactElement}
 */
const createGrid = (type, elements, customGutter) => {
  let cols = [];

  switch (type) {
    case ContainerLargeType.B1:
      cols = [
        { colAmount: { xl: 3.5, lg: 3.5, md: 3.5, sm: 12, xs: 12 } },
        { colAmount: { xl: 8, lg: 8, md: 8, sm: 12, xs: 12 } },
      ];
      return createCols(cols, elements, customGutter);
    case ContainerLargeType.B2:
      cols = [
        { colAmount: { xl: 8, lg: 8, md: 8, sm: 12, xs: 12 } },
        { colAmount: { xl: 3.5, lg: 3.5, md: 3.5, sm: 12, xs: 12 } },
      ];
      return createCols(cols, elements, customGutter);
    case ContainerLargeType.C:
      cols = [
        { colAmount: { xl: 4, lg: 4, md: 4, sm: 12, xs: 12 } },
        { colAmount: { xl: 4, lg: 4, md: 4, sm: 12, xs: 12 } },
        { colAmount: { xl: 4, lg: 4, md: 4, sm: 12, xs: 12 } },
      ];
      return createCols(cols, elements, customGutter, true);
    default:
      cols = [{ colAmount: { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 } }];
      return createCols(cols, elements, customGutter);
  }
};

export default createGrid;
